import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { eDropdownDirection } from '../../directives/dropdown.directive';

@Component({
    selector: 'fk-dropdown-modal-decorator',
    imports: [
        CommonModule,
    ],
    templateUrl: './dropdown-container.component.html',
    styleUrls: ['./dropdown-container.component.scss']
})
export class DropdownContainerComponent {
  @Input()
  content!: TemplateRef<any>;

  @Input()
  direction: eDropdownDirection = 'bottom';

  @Input()
  hasBaseClass: boolean = true;

  @Input()
  @HostBinding('style')
  positionStyle: { top?: string, left?: string, opacity?: number, 'z-index'?: number } = {};

  protected getDirectionStyles(): string {
    switch (this.direction) {
      case 'top': {
        return 'fk-mb2';
      }
      case 'left': {
        return 'fk-mr2';
      }
      case 'right': {
        return 'fk-ml2';
      }
      case 'bottom':
      default : {
        return 'fk-mt2';
      }
    }
  }
}
